import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const getPreemptiveData = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/preemptiveData', METHOD_TYPES.GET, data, callback);
};

export const getWorkFlowData = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/workflows', METHOD_TYPES.GET, data, callback);
};

export const deleteWorkflow = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/workflow', METHOD_TYPES.DELETE, data, callback);
};

export const updateWorkflow = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/workflow', METHOD_TYPES.PUT, data, callback);
};

export const createWorkflow = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/workflow', METHOD_TYPES.POST, data, callback);
};

export const getWorkflowModel = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/workflow', METHOD_TYPES.GET, data, callback);
};

export const saveWorkflowDiagram = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/workflowUI', METHOD_TYPES.PUT, data, callback);
};

export const getWorkflowNodeDetails = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/node', METHOD_TYPES.GET, data, callback);
};

export const createEntityTypeNode = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/addNodeToWorkflow', METHOD_TYPES.POST, data, callback);
};

export const updateEntityTypeNode = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/node', METHOD_TYPES.PUT, data, callback);
};

export const createWorkflowTypeNode = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/addWorkflowToUI', METHOD_TYPES.POST, data, callback);
};

export const updateWorkflowTypeNode = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/updateWorflowInWorkflow', METHOD_TYPES.POST, data, callback);
};



// WEBPACK FOOTER //
// ./src/data/redux/botbuilder_details/api.js